import { AccessState } from './location.model';

export const NO_LOCATIONS = 'NO_LOCATIONS';

export const ACCESS_STATES: readonly AccessState[] = ['FULL', 'SCOPED', 'NO_ASSIGNMENTS'];
